import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { onInput, setModelData, onKeyValueInput, onKeyValueDelete } from '../../actions/admin/forms';
import DetailsButtons from '../../components/admin/forms/DetailsButtons';
import { currentPath } from '../../selectors/router';
import * as selectors from '../../selectors/admin/forms';
import { organizationsOptionsSelector, contextSubjectSelector } from '../../selectors/admin/context';
import { ifPermission, PERMISSIONS } from '../../constants/authentication/permissions';
import { UserContext } from '../../Application';
import Loading from '../../components/helpers/Loading';
import { currentUserSelector } from '../../selectors/authentication';

class DetailsView extends Component {
    state = { showMode: true, initialData: null };

    componentDidMount() {
        this._initForm();
    }
    componentDidUpdate() {
        this._initForm();
    }
    _initForm() {
        if (!this.props.fetched && !this.props.fetching && this.props.isUpdateForm && this.props.fetchModel) {
            this.props.fetchModel(this.props.modelId);
        }
        if (!this.props.fetchedDependencies && !this.props.fetchingDependencies && this.props.fetchDependencies) {
            this.props.fetchDependencies(this.props.contextId, this.props.user, this.props.type);
        }
        if (!this.props.data.id && this.props.contextId && !this.props.data.organizationId) {
            this._onInput(this.props.contextId, 'organizationId', true);
            this._onInput([this.props.contextId], 'organizationIds', true);
        }
        if (this.props.inputData.subContextId && !this.props.data[`${this.props.inputData.subContext}Id`]) {
            this._onInput(this.props.inputData.subContextId, `${this.props.inputData.subContext}Id`, true);
        }
    }
    _onInput = (value, field, silence = false) => this.props.onInput(this.props.model, field, value, silence);
    _onKeyValueInput = (field, subField, index, value) =>
        this.props.onKeyValueInput(this.props.model, field, subField, index, value);
    _onKeyValueDelete = (field, index) => this.props.onKeyValueDelete(this.props.model, field, index);
    _preventDefault = e => e.preventDefault();
    submit = () => {
        if (this.props.submitAction) {
            this.props.submitAction(this.props.modelId, this.props.data);
        } else {
            this.defaultSubmit();
        }
    };
    defaultSubmit = () => {
        this.props[`${this.props.isUpdateForm ? 'update' : 'create'}Action`](
            this.props.data,
            this.props.modelId,
            this.props.inputData,
            () => this.setState({ showMode: this.props.isUpdateForm })
        );
    };
    _toggleMode = () => {
        if (this.state.showMode) {
            this.setState({ showMode: false, initialData: { ...this.props.data } });
        } else {
            this.props.setModelData(this.props.model, this.state.initialData);
            this.setState({ showMode: true, initialData: null });
        }
    };
    render() {
        const inShowMode = this.props.withShowMode && this.state.showMode;
        const EditView = this.props.editView;
        const ShowView = this.props.showView;
        const loadingLabel = this.props.submitting
            ? 'Submitting form...'
            : this.props.fetching
            ? 'Loading details...'
            : 'Loading dependencies...';
        return (
            <React.Fragment>
                {this.props.isLoading ? <Loading label={loadingLabel} className={'is-big is-absolute'} /> : null}
                <UserContext.Consumer>
                    {user => (
                        <form
                            className={`ckp-admin-forms  ${this.props.isLoading ? 'u-invisible' : ''}`}
                            onSubmit={this._preventDefault}
                        >
                            {ifPermission(
                                user,
                                PERMISSIONS[`${this.props.model.toUpperCase()}_EDIT`],
                                <DetailsButtons
                                    dropdown={this.props.dropdown}
                                    currentPath={this.props.currentPath}
                                    subContext={this.props.inputData.subContext}
                                    edited={this.props.forceEdited || this.props.edited}
                                    canSubmit={this.props.canSubmit}
                                    onSubmit={this.submit}
                                    model={this.props.model}
                                    editButton={inShowMode}
                                    onCancel={this.props.withShowMode ? this._toggleMode : null}
                                    onEdit={this._toggleMode}
                                />
                            )}
                            {inShowMode ? (
                                <ShowView
                                    data={this.props.data}
                                    contextOptions={this.props.contextOptions}
                                    dependencies={this.props.dependencies}
                                />
                            ) : (
                                <EditView
                                    metadata={this.props.inputData}
                                    withContext={!!this.props.contextId}
                                    context={this.props.contextId}
                                    contextOptions={this.props.contextOptions}
                                    dependencies={this.props.dependencies}
                                    errors={this.props.errors}
                                    data={this.props.data}
                                    onInput={this._onInput}
                                    onKeyValueInput={this._onKeyValueInput}
                                    onKeyValueDelete={this._onKeyValueDelete}
                                    isUpdate={this.props.isUpdateForm}
                                />
                            )}
                        </form>
                    )}
                </UserContext.Consumer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, props) => ({
    data: selectors.formDataSelector(state, props),
    user: currentUserSelector(state),
    currentPath: currentPath(state),
    edited: selectors.editedSelector(state),
    canSubmit: selectors.canSubmit(state, props),
    submitting: selectors.submittingSelector(state),
    errors: selectors.errorsSelector(state),
    fetched: selectors.fetchedSelector(state),
    fetching: selectors.fetchingSelector(state),
    fetchedDependencies: selectors.fetchedDependenciesSelector(state),
    fetchingDependencies: selectors.fetchingDependenciesSelector(state),
    dependencies: selectors.dependenciesSelector(state),
    isLoading: selectors.formsIsLoadingSelector(state),
    contextOptions: organizationsOptionsSelector(state),
    contextId: contextSubjectSelector(state),
    isUpdateForm: selectors.isUpdateFormSelector(state, props)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ onInput, onKeyValueInput, onKeyValueDelete, setModelData }, dispatch);

DetailsView.defaultProps = { inputData: {} };

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(DetailsView);



// WEBPACK FOOTER //
// ./src/containers/admin/DetailsView.js